module.exports = "<div class=\"btn\" (click)=\"onClick.emit()\">\n  <span class=\"btn__text\">{{ title }}</span>\n</div>\n"